<script context="module">
	// REPL for stopAll: https://svelte.dev/repl/316363bd1ea047639c9ffecfde84f741?version=3.29.4
	const playersObjs = {};

	export function stopAll(except) {
		Object.entries(playersObjs).forEach(([id, player]) => {
			if (id !== except) {
				player.pauseAudio(false);
			}
		});
	}
</script>

<script>
	import AudioSnippet from "./AudioSnippet/AudioSnippet.svelte";
	import ProgressBarTime from "./AudioSnippet/ProgressBarTime.svelte";
	import { onMount, onDestroy } from "svelte";

	import iconSpotify from "../images/spotify.svg";
	import iconYoutube from "../images/youtube.svg";

	export let id;
	export let rank;
	export let cover;
	export let year;
	export let title;
	export let artist;
	export let snippet;
	export let linkSpotify;
	export let linkYoutube;

	let progress;
	let player;
	export let isPlaying;

	onMount(() => {
		if (snippet) {
			playersObjs[id] = player;
		}
	});

	onDestroy(() => {
		const player = playersObjs[id];
		if (player) player.pauseAudio(false);
		delete playersObjs[id];
	});
</script>

<td class="rank-cell above-textwidth-only">
	<div class="rank">{rank}.</div>
</td>
<td class="cover">
	<img src={cover} alt="Album cover of the song {title} by {artist}" />
</td>
<td class="song">
	<div class="rank below-textwidth-only">{rank}.</div>
	<div class="title">{title}</div>
	<div class="song-info">
		<div class="artist">{artist}</div>
		<div class="year">{year}</div>
	</div>
	{#if snippet}
		<div class="progress-bar">
			<ProgressBarTime {progress} />
		</div>
	{/if}
</td>

<td class="snippet">
	<AudioSnippet
		{id}
		url={snippet}
		{title}
		{artist}
		coverUrl={cover}
		hideProgressBar={true}
		bind:progress
		bind:this={player}
		on:play
		bind:isPlaying
	/>
</td>
<td class="links">
	<div class="links__inner">
		<a href={linkYoutube} target="_blank" rel="noopener noreferrer">
			<img src={iconYoutube} alt="Youtube logo" />
		</a>
		<a href={linkSpotify} target="_blank" rel="noopener noreferrer">
			<img src={iconSpotify} alt="Spotify logo" />
		</a>
	</div>
</td>

<style lang="scss">
	td {
		padding-top: 3px;

		img {
			display: inline;
		}

		@media (min-width: $breakpoint-textwidth) {
			vertical-align: top;
			padding-top: 12px;
		}
	}

	.cover {
		img {
			border-radius: 7px;
			width: 52px;
			height: 52px;
			box-shadow: 0px 4px 4px #000000;
			margin-right: 15px;
		}
	}

	.song {
		width: 100%;

		.title {
			font-weight: $bold;
			font-size: 14px;
			line-height: 17px;
			margin-bottom: 2px;

			@media (min-width: $breakpoint-textwidth) {
				font-size: 18px;
				margin-bottom: 4px;
			}
		}

		.song-info {
			display: flex;
			align-items: flex-end;
			margin-bottom: 6px;
			font-size: 12px;
			line-height: 14px;

			@media (min-width: $breakpoint-textwidth) {
				font-size: 15px;
				line-height: 18px;
			}
		}

		.artist {
			margin-right: 5px;
		}

		.year {
			color: #797979;
		}
	}

	.rank-cell {
		min-width: 55px;
	}

	.rank {
		margin-bottom: 2px;
		font-family: $ff-serif;
		font-weight: $bold;
		font-size: 20px;
		line-height: 22px;
		color: #908f9d;
		margin-right: 5px;

		.above-textwidth-only > & {
			font-size: 28px;
			line-height: unset;
			margin-left: 6px;
		}
	}

	.snippet {
		position: relative;

		@media (min-width: $breakpoint-textwidth) {
			min-width: 90px;
		}

		&::after {
			content: "";
			display: block;
			height: 70%;
			width: 1px;
			background-color: $songsgrey;
			position: absolute;
			top: 15%;
			right: 0px;
		}
	}

	.links {
		&__inner {
			padding-top: 8px;
			padding-left: 5px;
			display: flex;
			flex-direction: column;
			align-items: center;

			@media (min-width: $breakpoint-textwidth) {
				flex-direction: row;
				justify-content: space-around;
				gap: 18px;
				margin: 0 12px;
			}

			> a:first-child {
				margin-bottom: 3px;
			}
		}

		img {
			@media (min-width: $breakpoint-textwidth) {
				height: 32px;
				width: 32px;
			}
		}
	}
</style>
